export function getMaterialBaseName(materialName) {
  return materialName.replace(/\s*\d+\s*mm\s*$/i, "").trim() || materialName;
}

export function formatMaterialLabel(materialName, thickness) {
  return `${getMaterialBaseName(materialName)} ${thickness} mm`;
}

export function summarizeMaterialPlan(materialName, breakdown = []) {
  if (!breakdown.length) return materialName;

  const thicknesses = breakdown.map((group) => group.thickness);
  const unique = [...new Set(thicknesses)];

  if (unique.length === 1) {
    return formatMaterialLabel(materialName, unique[0]);
  }

  const base = getMaterialBaseName(materialName);
  return `${base} (${unique.map((thickness) => `${thickness} mm`).join(", ")})`;
}
